import type { CourseWithoutBlocks } from '@/types/course'
import { useAppSelector } from '@/store/hooks'
import type { ContentLang } from '../../editorSlice'
import { hasTranslationRow } from '../../lib/courseTranslation'
import { resolveLang } from '../studio/seedContentLang'
import { useHasStartedTranslationRun } from '../studio/useBlocksInRun'

/**
 * Какие языки курса доступны для правки — одно правило на меню языка шапки и быстрые
 * кружки в углу холста. Базовый — по реестру (незнакомый `sourceLang` не становится
 * «базовым»); второй «добавлен» по прежнему широкому признаку: заливка мимо студии
 * тоже язык.
 */
export const useAvailableContentLangs = (course: CourseWithoutBlocks) => {
  const current = useAppSelector((s) => s.editor.contentLang)
  const hasStartedRun = useHasStartedTranslationRun(course.id)
  const base: ContentLang = resolveLang(course.sourceLang)
  const other: ContentLang = base === 'ru' ? 'en' : 'ru'
  const otherAdded = hasTranslationRow(course, hasStartedRun) || current === other
  const available: ContentLang[] = otherAdded ? [base, other] : [base]
  return { current, base, other, otherAdded, available, hasStartedRun }
}
